<template>
    <div>
        <div class="page-filter-box">
			<el-row :gutter="20">						
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="TimeStatus"  placeholder="请选择" size="small">
						<el-option label="查看截止目前的数据" :value="1"></el-option>
						<el-option label="自定义查询时间段" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8" v-if="TimeStatus == 2" >
					<el-date-picker						
						v-model="datetimerange"
						type="datetimerange"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						class="fl"
						size="small"
						value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="['00:00:00', '23:59:59']"
						align="right"
						unlink-panels
						>
					</el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/missTicket/exportRegisteredUsers') && dataList && dataList.length > 0" type="primary" icon="el-icon-download" @click="download" :loading="downLoading">导出登记用户</el-button>
        </div>
        <h3 v-if="data" class="MT20">当前演出开票登记总人数：<span class="color-danger">{{data.openRecordNum || 0}}</span>，缺票登记总人数：<span class="color-danger">{{data.missNum || 0}}</span>，
        总登记人数：<span class="color-danger">{{data.totalNum || 0}}</span>
        </h3>
        <div class="content MT20" v-loading="chartLoading">
           <div id="chartContainer1" ref="chartContainer1"></div>
        </div>
        
        <div class="page-list-box MT20">
            <el-table
               :data="dataList"
               border
               style="width: 100%"
               v-loading="dataLoading"
               size="small"
               stripe
            >
                <el-table-column type="expand" label="展开">
                    <template slot-scope="props">
                        <template v-if="props.row.notifyRecords && props.row.notifyRecords.length > 0">
                            <div v-for="(item,index) in props.row.notifyRecords" :key="index" :class="{'MT10':index > 0}">
                                <span><span class="color-info">加票通知制作人：</span>{{item.operator}}</span>
                                <span class="ML20"><span class="color-info">加票通知时间：</span>{{item.operatorTime}}</span>
                                <span class="ML20"><span class="color-info">通知人数：</span>{{item.num}}</span>
                            </div>
                        </template>
                        <div v-else>未发送过加票通知</div>
                    </template>
                </el-table-column>            
                <el-table-column prop="sessionName" label="场次名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ticketName" label="票品名称" ></el-table-column>
                <el-table-column prop="price" label="售价" ></el-table-column>
                <el-table-column prop="totalStock" label="总库存" ></el-table-column>
                <el-table-column prop="remainingStock" label="剩余库存" ></el-table-column>
        		<el-table-column prop="startTime" label="票品销售时间" min-width="150">
        			<template slot-scope="scope">
        			    {{scope.row.startTime ? `开售：${scope.row.startTime}` : ''}}
        			    <p>停售：{{scope.row.endTime ? `${scope.row.endTime}` : ''}}</p>
        			</template>
        		</el-table-column>
                <el-table-column prop="openTicketRegisterNum" label="开票登记人数" min-width="100"></el-table-column>                
                <el-table-column prop="lackTicketRegisterNum" label="缺票登记人数" min-width="100"></el-table-column>
                <!-- <el-table-column prop="endTime" label="票品停售时间" min-width="150"></el-table-column> -->
                <el-table-column prop="notBuyNum" label="尚未购票人数" min-width="100"></el-table-column>
                <el-table-column prop="notNotifyNum" label="加票尚未通知人数" min-width="120"></el-table-column>               
                <el-table-column v-if="data && !data.haveEditAudit" fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <!-- <el-button
                            v-if="$utils.have('/missTicket/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.recordId)"
                            >管理</el-button
                        >    42479 -->
                        <el-button
                            v-if="scope.row.canSendNotify && $utils.have('/missTicket/sendNotify')"
                            type="text"
                            size="small"
                            @click="sendNotify(scope.row)"
                            >发送加票通知</el-button
                        >                       
                    </template>
                </el-table-column>
           </el-table>
        </div>
        <div v-if="record" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDatalist"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="record.totalCount || 0">
            </el-pagination>
        </div>
        
    </div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
	pageNo:1,
	startTime:'',
	endTime:'',
	
}
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        },
        
    },
    components: {  },
    data() {
        return{
            dataLoading:false,
            data: null,
            record: null,
            dataList:[],
        	params:{
        	    ...defaultParams,
        	    pageNo:parseInt(this.$route.query.pageNo || 1),
        	    pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
        		startTime:this.$route.query.startTime || '',
        		endTime:this.$route.query.endTime || '',
        	},
        	datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
        	recordId:'',
            redirect: this.$route.query.redirect,
            downLoading: false,
        	TimeStatus:1,
        	timeType:0,
        	chartLoading:false
        }
    },
   created() {
       this.getDatalist()
   },
    methods: {
       //获取列表
       getDatalist(){			
       	var startTime = this.datetimerange && this.datetimerange[0] || '';
       	var endTime = this.datetimerange && this.datetimerange[1] || '';			
       	if( this.TimeStatus == 2 && (startTime == '' && endTime =='' )){
       		return this.$message.warning("时间段不能为空！");
       	}
	   this.dataLoading = true;
	   this.$request({
		   url: "/missTicket/pageList",
		   data: { ...this.params,
			activityId: parseInt(this.activityId),
			startTime:startTime,
			endTime:endTime,
		},
		   method: "post",
	   })
		   .then((res) => {
			   const { state, msg, result } = res.data;
			   if (state == 1) {						
				   this.data = result;
				   this.record = result.missingTicketRecordPageVO;
				   this.dataList = result.missingTicketRecordPageVO.result;
				   this.$emit('update:activityName', result.activityName);
				   this.$emit('update:haveEditAudit', result.haveEditAudit);
			   } else {
				   this.$message.error(msg || "获取数据失败,请重试");
			   }
		   })
		   .catch(() => {
			   this.$message.error("获取数据失败,请重试");
		   })
		   .finally(() => {
			   this.dataLoading = false;
		   });
       },
       //选择pageSize
       handleSizeChange(e) {
           this.params.pageNo = 1;
           this.params.pageSize = e;
           this.getDatalist();
       },
       //搜索
       search() {
			this.params.pageNo = 1;
			this.getDatalist();       	
       },
       //重置搜索
       reset() {
        this.datetimerange = [];
       	this.TimeStatus = 1
           this.params = {
               ...defaultParams,
               pageSize: this.params.pageSize,
           };
           this.getDatalist();			
       },
	   
	   //发送加票通知
	   sendNotify(item){
	       this.$confirm('确定发送加票通知？', '提示', {
	           type: 'warning',
	           center: true,
	           closeOnClickModal: false
	       }).then( () => {
	           this.$request({
	               url: '/missTicket/sendNotify',
	               method: 'POST',
	               params: {recordId:item.recordId},
	           }).then(res=> {
	               let { state, msg } = res.data;
	               if (state == 1) {
	                   this.$message.success("操作成功");
	                   this.getDatalist();
	               }else{
	                   this.$message.error(msg || "请求失败");
	               }
	           }).catch( () => {
	               this.$message.error("操作失败");
	           })
	       }).catch( () => {})
	   },
	   //导出
	   async download(){
	       let filePath;
	       this.downLoading = true;
	       const res = await this.$request({
	           url:'/missTicket/exportRegisteredUsers',
	           method: 'post',
	           params: {
	               activityId: parseInt(this.activityId),
	               uid: this.$utils.uuid()
	           },
	       })
	           .catch(err => {
	               this.$message({message: err.message, type: 'error'});
	           })
	       const{state,msg,result} = res.data;
	       if(state == 1 && result){
	           filePath = result.url;
	       }else{
	           this.downLoading = false;
	           return this.$message.error(msg || '下载失败');
	       }   
	   
	       await downloadFileTmp(filePath,this.activityId+'票品登记用户.'+this.$utils.getFileType(filePath));
	   
	       this.downLoading = false;
	   },
        
    }
}
</script>